(() => {
  const data = document.currentScript?.dataset || {};

  window.klaviyo = window.klaviyo || [];
  window.klaviyo.init({
    account: data.account || '',
    platform: 'shopify',
    display_on_policy_continue: true,
  });

  window.klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: data.productPageText || 'Notify Me When Available',
      product_page_class: 'btn',
      product_page_text_align: 'center',
      product_page_margin: '0px',
      replace_anchor: false,
    },
    modal: {
      headline: '{product_name}',
      body_content: data.bodyContent || '',
      email_field_label: data.emailFieldLabel || '',
      button_label: data.buttonLabel || '',
      subscription_success_label: data.subscriptionSuccessLabel || '',
      footer_content: '',
      close_label: data.closeLabel || '',
      additional_styles: data.additionalStyles || '',
      font_family: '"TradeGothicLTStd-BdCn20", sans-serif;',
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#000',
      button_text_color: '#000',
      button_background_color: '#1FDCC0',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500',
    },
  });
})();
